export default "__VITE_ASSET__SD_Jt$6e__"